import { render } from "./MultipleChoiceQuestion.vue?vue&type=template&id=31a917bf&scoped=true"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js"

import "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=31a917bf&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a917bf"]])

export default __exports__